import {Pipe, PipeTransform} from '@angular/core';

/**
 * This pipe handles filtering the list.
 */
@Pipe({
  name: 'listFilter',
})
export class ListFilterPipe implements PipeTransform {

  /**
   * Filters the list by the given text which should be searched in the given field.
   * @param list the list to be filtered.
   * @param filterText the text by which the results are filtered.
   * @param field the field by which the results are filtered.
   */
  transform(list: any[], filterText: string, field: string): any[] {
    return list ? list.filter(item => item[field].search(new RegExp(filterText, 'i')) > -1) : [];
  }

}
